var $J = jQuery.noConflict();
/* function to check if the selector exists or if the selector returns results */
$J.fn.exists = function () {
    return this.length > 0;
}; // global SWITCH object

var SWITCH = SWITCH || {};

SWITCH.utility = {
    ajaxRequest: function (data, url, enableUiBlock, elementSelector) {
        if (typeof (enableUiBlock) === 'undefined') {
            enableUiBlock = false;
        }

        if (enableUiBlock && (typeof (elementSelector) !== 'undefined' && elementSelector != '')) {
            jQuery(elementSelector).block({ message: 'loading <i class="fa fa-spin fa-refresh"></i>' });
        }

        return jQuery.ajax({
            url: url,
            data: data,
            global: false,
            type: 'POST',
            dataType: 'json',
            success: function () {
                if (typeof (enableUiBlock) !== 'undefined' && enableUiBlock && (typeof (elementSelector) !== 'undefined' && elementSelector != '')) {
                    jQuery(elementSelector).unblock();
                }
            }
        });
    },

    blockedUI: function (selector) {
        if ((typeof (selector) !== 'undefined' && selector != '')) {
            jQuery(selector).block({ message: 'loading <i class="fa fa-spin fa-refresh"></i>' });
        }
    },

    unblockedUI: function (selector) {
        if ((typeof (selector) !== 'undefined' && selector != '')) {
            jQuery(selector).unblock();
        }
    }
};


(function ($, sf, SWITCH) {

    var icons = {
        marker: '/assets/images/maps/map-marker.png',
        marker_selected: '/assets/images/maps/map-marker-selected.png',
        marker_cluster_sm: '/assets/images/maps/map-marker-cluster-sm.png',
        marker_cluster_md: '/assets/images/maps/map-marker-cluster-md.png',
        marker_cluster_lg: '/assets/images/maps/map-marker-cluster-lg.png'
    };

    /* INITIALIZE DEFAULT SETTINGS */
    var _settings = {
        center: { lat: 0, lng: 0 },
        country: 'au',
        zoom: 0,
        API_KEY: googleMapApiKey,
        elems: {
            geocodeInputTop: 'address1',
            geocodeInput: 'address2',
            geocodeInputSearch: '40701749618a44579447eadd65622baa',
            jqStoreList: '#storeList',
            jqStoreListItem: '.storeListItem',
            jqStoreListItemDetails: '.storeDetails',
            jqStoreListItemTemplate: '#storeItemTemplate',
            jqStoreMarkerInfoTemplate: '#storeMarkerInfoTemplate',
            jqStoreActiveListItem: '.storeListItem.selected',
            jqStoreListLink: '.detailsLink',
            jqStoreFilter: '.sf-store-filter'
            // jqStoreFilterAll: '.sf-store-filter-checkbox-all',
            // jqStoreFilterDescription: '.finderInfo',
        }
    };

    var _urls = {
        js_finder: function () {
            return 'https://maps.googleapis.com/maps/api/js?key=' + _settings.API_KEY + '&libraries=places&callback=sf_initialize_finder';
        },
        js_dealer: function () {
            return 'https://maps.googleapis.com/maps/api/js?key=' + _settings.API_KEY + '&libraries=places&callback=sf_initialize_dealer';
        },
        geocode: function (address) {
            return 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=' + _settings.API_KEY;
        },
        findStore: function () {
            return '/Utilities/dealer/getdealers';
        }
    };


    var _map = {},
		_autocomplete = {},
		_autocompleteTop = {},
		// _selected = {},
		_stores = {
		    raw: [],
		    // HasShowRoom: false,
		    // hasReseller: false,
		    setRaw: function (data) {
		        this.raw = data;
		    },
		    _filter: 'showroom',
		    filter: function () {
		        var dis = this;
		        // if (dis._filter === 'reseller') {
		        var data = [];
		        for (var i = 0; i < dis.raw.length; i++) {
		            if (!dis.raw[i].IsAShowroom) {
		                data.push(dis.raw[i]);
		            }
		        }
		        return data;
		        // }
		        // if (dis._filter === 'showroom') {
		        // 	var data = [];
		        // 	for (var i = 0; i < dis.raw.length; i++) {
		        // 		if (dis.raw[i].IsAShowroom) {
		        // 			data.push(dis.raw[i]);
		        // 		}
		        // 	}
		        // 	return data;
		        // }
		    },
		    toList: function () {
		        var data = this.filter();
		        data = data.sort(function (a, b) {
		            return (a.DistanceInKm > b.DistanceInKm) ? 1 : -1;
		        });
		        for (var i = 0; i < data.length; i++) {
		            this.decorateOne(data[i]);
		        }
		        return data;
		    },
		    toLatLngArray: function () {
		        var arr = [],
					item,
					dis = this;
		        var data = dis.filter();
		        if (data) {
		            for (var i = 0; i < data.length; i++) {
		                item = data[i];
		                arr.push({
		                    lat: parseFloat(item.Latitude),
		                    lng: parseFloat(item.Longitude),
		                    id: item.SitecoreItemId,
		                    name: item.Name,
		                    IsAShowroom: item.IsAShowroom
		                });
		            }
		        }
		        return arr;
		    },
		    toGoogleLatLngArray: function () {
		        var arr = [],
					item,
					dis = this;
		        var data = dis.filter();
		        if (data) {
		            for (var i = 0; i < data.length; i++) {
		                item = data[i];
		                arr.push(new google.maps.LatLng(parseFloat(item.Latitude), parseFloat(item.Longitude)));
		            }
		        }
		        return arr;
		    },
		    decorateOne: function (item) {
		        if (item) {
		            // set favorite dealer return url
		            var returnUrl = getUrlVars(window.location.href)['returnurl'];
		            if (returnUrl != undefined && returnUrl != '') {
		                item.ReturnUrl = decodeEntities(returnUrl);
		            }

		            // button text for Enquire or Favourite in the dealer list item
		            item.DealerItemButtonText = 'Enquire';
		            if (window.location.href.indexOf('favorite') != -1) {
		                item.DealerItemButtonText = 'Favourite';
		            }

		            // button text for VIEW or "SET AS Favourite" in the dealer popup info window
		            item.DealerInfoButtonText = 'View';
		            if (window.location.href.indexOf('favorite') != -1) {
		                item.DealerInfoButtonText = 'Set as Favourite';
		            }

		            // decorate address
		            item.AddressCompiled = '';
		            if (item.AddressLine1) {
		                item.AddressCompiled += item.AddressLine1 + ', <br/>';
		            }
		            if (item.AddressLine2) {
		                item.AddressCompiled += item.AddressLine2 + ', <br/>';
		            }
		            if (item.AddressLine3) {
		                item.AddressCompiled += item.AddressLine3 + ', <br/>';
		            }
		            if (item.AddressCity) {
		                item.AddressCompiled += item.AddressCity + ', ';
		            }
		            if (item.AddressState) {
		                item.AddressCompiled += item.AddressState + ' ';
		            }
		            if (item.AddressPostcode) {
		                item.AddressCompiled += item.AddressPostcode;
		            }
		            if (item.AddressRegion) {
		                item.AddressCompiled += item.AddressRegion;
		            }
		            // if (item.AddressCountry) {
		            // 	item.AddressCompiled += item.AddressCountry + ', ';
		            // }
		            // website url
		            item.WebsiteUrlCompiled = '';
		            item.Url = '';
		            if (item.WebsiteUrl) {
		                var normalizeHref = item.WebsiteUrl;
		                if (normalizeHref.indexOf('http') === -1) {
		                    normalizeHref = 'http://' + item.WebsiteUrl;
		                }

		                item.WebsiteUrlCompiled = normalizeHref;
		                item.Url = item.WebsiteUrl;
		            }
		            // decorate phone
		            item.PhoneOrMobile = '';
		            if (item.Phone) {
		                item.PhoneOrMobile = item.Phone;
		            } else if (item.Mobile) {
		                item.PhoneOrMobile = item.Mobile;
		            }

		            // website email
		            item.EmailHtml = '';
		            // if (typeof(item.Email) !== 'undefined' && item.Email != '') {
		            // 	item.EmailHtml = '<span class="Email">Email: <a href="mailto:' + item.Email + '" target="_blank">' + item.Email + '</a></span><br/>';
		            // }

		            // image element
		            item.ImageElementCompiled = '';
		            if (item.Logo && item.Logo.Src) {
		                item.ImageElementCompiled = '<img src="' + item.Logo.Src + '" height="90px" width="90px">';
		            }
		        }
		    },
		    getById: function (itemId) {
		        var found = false,
					dis = this;
		        var data = dis.filter();
		        if (data) {
		            for (var i = 0; i < data.length; i++) {
		                if (data[i].SitecoreItemId === itemId) {
		                    found = data[i];
		                    break;
		                }
		            }
		            if (found) {
		                dis.decorateOne(found);
		            }
		        }
		        return found;
		    },
		    getMarkerInfo: function (itemId) {
		        var found = this.getById(itemId);
		        if (found) {
		            var rendered = $(_settings.elems.jqStoreMarkerInfoTemplate).tmpl(found);
		            return rendered;
		        }
		        return false;
		    }
		};


    /******************************************************************************/
    /*
	 * private functions
	 */

    function initializeMap() {
        var mapOptions = {
            center: new google.maps.LatLng(_settings.center.lat, _settings.center.lng),
            zoom: _settings.zoom,
            scrollwheel: false
        };
        _map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
        window.wow = _map;
    }

    function getApiScript(src) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        document.body.appendChild(script);
    }

    function setAutoComplete() {
        var locationStr = getUrlVars(window.location.href)['location'];
        if (locationStr != undefined && locationStr != '') {
            var location = decodeEntities(locationStr);
            $('#address2').val(location);

            _settings.zoom = 16;
            refreshMap();

        } else {
            $('#address2').val('');
            localStorage.removeItem('place');
        }
    }

    function getUrlVars(url) {
        var vars = [],
			hash;
        var hashes = url.slice(url.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    function decodeEntities(encodedString) {
        return unescape(encodedString).replace(/\+/g, ' ');
    }

    function encodeEntities(str) {
        return escape(str.replace(/ /g, '+'));
    }

    function initializeAutoComplete() {
        // initialize auto complete for "Find A Dealer" in top utility navigation
        _autocompleteTop = new google.maps.places.Autocomplete(
			document.getElementById(_settings.elems.geocodeInputTop), {
			    types: ['(regions)'],
			    componentRestrictions: { country: _settings.country }
			}
		);

        google.maps.event.addListener(_autocompleteTop, 'place_changed', function () {
            var getPlaceVar = _autocompleteTop.getPlace();
            localStorage.setItem('place', JSON.stringify(getPlaceVar));

            if (!getPlaceVar.geometry || !getPlaceVar.geometry.location) {
                // User pressed the Enter key, or the Place Details request failed.
                window.alert("Please enter a valid suburb or postcode and select from the list");
                return;
            }

            if ($('#jsfindDealerSubmit').length && getPlaceVar.address_components != null) {
                $(".list-selection").hide();
                $('#jsfindDealerSubmit').submit();
            } else {

                $(".list-selection").show();
                return;
            }
        });

        // Create the autocomplete object, restricting the search to geographical location types.
        _autocomplete = new google.maps.places.Autocomplete(
			document.getElementById(_settings.elems.geocodeInput), {
			    types: ['(regions)'],
			    componentRestrictions: { country: _settings.country }
			}
		);

        // When the user selects an address from the dropdown
        google.maps.event.addListener(_autocomplete, 'place_changed', function () {
            var place = _autocomplete.getPlace();
            if (!place.geometry || !place.geometry.location) {
                // User pressed the Enter key, or the Place Details request failed.
                window.alert("Please enter a valid suburb or postcode and select from the list");
                return;
            }

            if ($('#jsPagefindDealerSubmit').length && place.address_components != null) {
                // begin place/geocode/address selected
                $(".select-from-list").hide();
                onPlaceSelected(place);
                //$('#jsPagefindDealerSubmit').submit();
            } else {
                $(".select-from-list").show();
                return;
            }
        });
    }

    function initializeAutoCompleteTop() {
        // initialize auto complete for "Find A Dealer" in top utility navigation
        _autocompleteTop = new google.maps.places.Autocomplete(
			document.getElementById(_settings.elems.geocodeInputTop), {
			    types: ['(regions)'],
			    componentRestrictions: { country: _settings.country }
			}
		);

        google.maps.event.addListener(_autocompleteTop, 'place_changed', function () {

            var getPlaceVar = _autocompleteTop.getPlace();
            localStorage.setItem('place', JSON.stringify(getPlaceVar));

            if (!getPlaceVar.geometry || !getPlaceVar.geometry.location) {
                // User pressed the Enter key, or the Place Details request failed.
                window.alert("Please enter a valid suburb or postcode and select from the list");
                return;
            }

            if ($('#jsfindDealerSubmit').length && getPlaceVar.address_components != null) {
                $(".list-selection").hide();
                $('#jsfindDealerSubmit').submit();
            } else {

                $(".list-selection").show();
                return;
            }
        });
    }

    function onPlaceSelected(place) {
        // set selected place/geocode/postcode/address
        localStorage.setItem('place', JSON.stringify(place));

        // AJAX to get data, meanwhile refresh map
        // refreshMapBySelectedPlace();
        // findStore();

        // Refresh page instead of AJAX
        var newUrl = '/find-a-dealer?location=';
        if (window.location.href.indexOf('favorite') != -1) {
            newUrl = '/set-favorite-dealer?location=';
        }
        var location = $('#address2').val();
        location = encodeEntities(location);
        var productFilterStr = getUrlVars(window.location.href)['f'];
        if (productFilterStr != undefined && productFilterStr != '') {
            newUrl = newUrl + location + "&f=" + productFilterStr;
        }
        else {
            newUrl = newUrl + location;
        }
        var returnUrl = getUrlVars(window.location.href)['returnurl'];
        if (returnUrl != undefined && returnUrl != '') {
            newUrl = newUrl + "&returnurl=" + returnUrl;
        }
        var excludeSpecialDealer = getUrlVars(window.location.href)['excludespecialdealer'];
        if (excludeSpecialDealer != undefined && excludeSpecialDealer != '') {
            newUrl = newUrl + "&excludespecialdealer=" + excludeSpecialDealer;
        }

        window.location.href = newUrl;

        _settings.zoom = 16;
        refreshMap();

    }

    function refreshMapBySelectedPlace() {
        if (typeof (localStorage.getItem('place')) !== 'undefined') {
            // set map settings
            var latlng = getLatLngFromPlace();
            _settings.center = latlng;

            // refresh map
            refreshMap();
        }
    }

    function refreshMap() {
        _map.setCenter(new google.maps.LatLng(_settings.center.lat, _settings.center.lng));
        _map.setZoom(_settings.zoom);
    }

    function findStore() {
        var data = {};
        
        if (localStorage.getItem('place') != null && findDealerSettings != null) {
            var latlng = getLatLngFromPlace();
            data = {
                // storeFinderConfigurationId: $('#storeConfigId').val(),
                // storesFolderId: $('#storesFolderId').val(),
                keyword: $('#address2').val(),
                latitude: latlng.lat,
                longitude: latlng.lng,
                radius: findDealerSettings.SearchSettings.radius,
                extendradius: findDealerSettings.SearchSettings.extendradius,
                productfilter: $('#productRangeFilter').val(),
                servicefilter: $('#productServiceRangeFilter').val(),
                brandfilter: $('.jsFilterbrands').val(),
                excludespecialdealer: $('#excludespecialdealer').val(),
            };
        } else {
            data = {
                keyword: '',
                latitude: _settings.center.lat,
                longitude: _settings.center.lng,
                radius: 3000,
                extendradius: 6000,
                productfilter: $('#productRangeFilter').val(),
                servicefilter: $('#productServiceRangeFilter').val(),
                brandfilter: $('.jsFilterbrands').val(),
                excludespecialdealer: $('#excludespecialdealer').val(),
            };
        }

        // mock ajax
        var request = SWITCH.utility.ajaxRequest(data, _urls.findStore(), true, '.sf-store-finder');
        request.done(function (result) {
            if (typeof result === 'string') {
                _stores.raw = eval(result);
                $(sf).trigger('result.find.store_finder');
            } else if (typeof result === 'object') {
                if (result.Stores.length == 0) {
                    $('#storeList').hide();
                    $('.findDealerNoResults').show();

                    _map.setZoom(5);


                } else {
                    $('#storeList').show();
                    $('.findDealerNoResults').hide();

                    _stores.raw = eval(result.Stores);
                    // _stores.HasShowRoom = eval(result.HasShowRoom);
                    // _stores.hasReseller = eval(result.HasReseller);
                    $(sf).trigger('result.find.store_finder');

                    // setTimeout(function () {
                    // 	if ((_stores.hasReseller && !_stores.HasShowRoom) || (!_stores.hasReseller && _stores.HasShowRoom)) {
                    // 		if (_stores.hasReseller) {
                    // 			$(document).find('.sf-store-list .sf-store-filters .reseller').click();
                    // 		} else if (_stores.HasShowRoom) {
                    // 			$(document).find('.sf-store-list .sf-store-filters .showroom').click();
                    // 		}
                    // 	}
                    // }, 100);
                }
            }

            // tooltip
            tooltipBasic();
        });
    }

    function tooltipBasic() {
        if ($('.tooltip').length) {
            $('.tooltip').each(function () {
                $(this).tooltipster({
                    content: $(this).data('tooltip'),
                    maxWidth: 320,
                    trigger: 'custom',
                    triggerOpen: {
                        click: true,
                        touchstart: true
                    },
                    triggerClose: {
                        click: true,
                        scroll: true,
                        tap: true
                    }
                });
            });
        }
    }

    function getLatLngFromPlace() {
        if (localStorage.getItem('place') != null) {
            var selected = JSON.parse(localStorage.getItem('place'));
            if (typeof (selected) !== 'undefined' && typeof (selected.geometry) !== 'undefined' && typeof (selected.geometry.location) !== 'undefined') {
                var latlng = {
                    lat: selected.geometry.location.lat,
                    lng: selected.geometry.location.lng
                };
                return latlng;
            }
        }
        return _settings.center;
    }

    $(sf).on('result.find.store_finder', function () {
        drawMapMarkers();
        drawList();
        // setupFilterDescription();

        // //hide filter option
        // if (_stores.hasReseller) {
        // 	$(document).find('.sf-store-list .sf-store-filters .reseller').removeAttr('style');
        // } else {
        // 	$(document).find('.sf-store-list .sf-store-filters .reseller').hide();
        // }

        // if (_stores.HasShowRoom) {
        // 	$(document).find('.sf-store-list .sf-store-filters .showroom').removeAttr('style');
        // } else {
        // 	$(document).find('.sf-store-list .sf-store-filters .showroom').hide();
        // }

        // if (_stores.hasReseller || _stores.HasShowRoom) {
        // 	$(document).find('.sf-store-list .sf-store-filters').removeAttr('style');
        // 	$(document).find('.sf-store-list .storeList').removeAttr('style');
        // } else {
        // 	$(document).find('.sf-store-list .sf-store-filters').hide();
        // 	$(document).find('.sf-store-list .storeList').hide();
        // }
    });

    var _miniInfoWindow,
		_realInfoWindow,
		_markers = [],
		_markerClusterer;

    var closeInfoWindows = function () {
        if (typeof _miniInfoWindow !== 'undefined') {
            _miniInfoWindow.close();
        }
        if (typeof _realInfoWindow !== 'undefined') {
            _realInfoWindow.close();
            _realInfoWindow.related_marker.setIcon(icons.marker);
        }
    };

    var infoWindowClosed = function (marker) {
        return function () {
            marker.setIcon(icons.marker);
        };
    };

    var singleMarkerClicked = function (marker) {
        return function () {
            closeInfoWindows();
            var infoStr = $('<div />').html($('#infoWindow').html());
            if (infoStr) {
                marker.setIcon(icons.marker_selected);
                _realInfoWindow = new google.maps.InfoWindow({ content: infoStr[0] });
                _realInfoWindow.related_marker = marker;
                _realInfoWindow.open(_map, marker);
                google.maps.event.addListener(_realInfoWindow, 'closeclick', infoWindowClosed(marker));
            }
        };
    };

    var markerClicked = function (marker) {
        return function () {
            closeInfoWindows();
            var infoStr = _stores.getMarkerInfo(marker.id);
            if (infoStr) {
                marker.setIcon(icons.marker_selected);
                _realInfoWindow = new google.maps.InfoWindow({ content: infoStr[0] });
                _realInfoWindow.related_marker = marker;
                _realInfoWindow.open(_map, marker);
                google.maps.event.addListener(_realInfoWindow, 'closeclick', infoWindowClosed(marker));
            }
            // find a dealer page
            if ($('#address2').length > 0) {
                focusToList(marker.id);
            }
        };
    };

    // var markerMouseOver = function (marker) {
    // 	return function () {
    // 		var go = false;
    // 		if (typeof _realInfoWindow === 'undefined') {
    // 			go = true;
    // 		} else {
    // 			if (_realInfoWindow.map === null) {
    // 				go = true;
    // 			} else {
    // 				go = _realInfoWindow.related_marker !== marker;
    // 			}
    // 		}
    // 		if (go) {
    // 			_miniInfoWindow = new google.maps.InfoWindow({
    // 				content: '<div id="" class="sf-marker-info"><strong class="name">' + marker.name + '</strong></div>'
    // 			});
    // 			_miniInfoWindow.open(_map, marker);
    // 		}
    // 	};
    // };

    var markerMouseOut = function () {
        return function () {
            if (typeof _miniInfoWindow !== 'undefined') {
                _miniInfoWindow.close();
            }
        };
    };

    function setAllMap(map) {
        for (var i = 0; i < _markers.length; i++) {
            _markers[i].setMap(map);
        }
    }

    function clearMarkers() {
        setAllMap(null);
        if (typeof _markerClusterer !== 'undefined') {
            _markerClusterer.clearMarkers();
        }
    }
    // window.clearMarkers = clearMarkers;

    function drawSingleMapMarker() {
        _markers = [];
        // generate marker
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(_settings.center.lat, _settings.center.lng),
            map: _map,
            icon: icons.marker
        });
        marker.name = $('.dealerDetailInfo').data('name');
        _markers.push(marker);
        // marker click event
        google.maps.event.addListener(marker, 'click', singleMarkerClicked(marker));
        // google.maps.event.addListener(marker, 'mouseover', markerMouseOver(marker));
        google.maps.event.addListener(marker, 'mouseout', markerMouseOut());
    }

    function drawMapMarkers() {
        if (_stores) {
            clearMarkers();
            var arr = _stores.toLatLngArray();
            _markers = [];
            for (var i = 0; i < arr.length; i++) {
                // generate marker
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(arr[i].lat, arr[i].lng),
                    map: _map,
                    icon: icons.marker
                });
                marker.id = arr[i].id;
                marker.name = arr[i].name;
                marker.IsAShowroom = arr[i].IsAShowroom;
                _markers.push(marker);
                // marker click event
                google.maps.event.addListener(marker, 'click', markerClicked(marker));
                // google.maps.event.addListener(marker, 'mouseover', markerMouseOver(marker));
                google.maps.event.addListener(marker, 'mouseout', markerMouseOut());
            } // endfor

            // set map center from the Postcode/Suburb (place) entered
            var latlng = getLatLngFromPlace();
            _settings.center = latlng;

            fitMarkers();
            clusterMarkers();

            //force zoom out if only one result
            if (arr.length == 1) {
                _map.setZoom(16);
            }
        } // endif
    }

    function clusterMarkers() {
        var mcSettings = {
            styles: [{
                url: icons.marker_cluster_sm,
                width: 32,
                height: 32,
                iconAnchor: [16, 16],
                textColor: '#fff',
                textSize: 14
            }, {
                url: icons.marker_cluster_md,
                width: 38,
                height: 38,
                iconAnchor: [19, 19],
                textColor: '#fff',
                textSize: 16
            }, {
                url: icons.marker_cluster_lg,
                width: 46,
                height: 46,
                iconAnchor: [23, 23],
                textColor: '#fff',
                textSize: 20
            }],
            zoomOnClick: true,
            averageCenter: true,
            minimumClusterSize: 4,
            gridSize: 40
        };
        _markerClusterer = new MarkerClusterer(_map, _markers, mcSettings);
    }

    function fitMarkers() {
        if (_stores) {
            var arr = _stores.toGoogleLatLngArray();
            if (arr.length > 0) {
                var bounds = new google.maps.LatLngBounds();
                for (var i = 0; i < arr.length; i++) {
                    bounds.extend(arr[i]);
                }
                _map.fitBounds(bounds);
            }
        }
    }

    function drawList() {
        $(_settings.elems.jqStoreList).removeClass('hide').empty();
        var list = _stores.toList();
        for (var i = 0; i < list.length; i++) {
            var item = list[i];
            $(_settings.elems.jqStoreListItemTemplate).tmpl(item).appendTo($(_settings.elems.jqStoreList));
        }
    }

    function focusToMarker(id) {
        var found = null;
        for (var i = 0; i < _markers.length; i++) {
            if (_markers[i].id === id) {
                found = _markers[i];
                break;
            }
        }
        if (found) {
            // _markerClusterer.setGridSize(1);
            if (_map.zoom < 15) {
                _map.setZoom(15);
            }
            _map.setCenter(found.getPosition());
            markerClicked(found)();
        }
    }

    function focusToList(id) {
        $(_settings.elems.jqStoreActiveListItem).removeClass('selected');
        $listItem = $(_settings.elems.jqStoreListItem + '[data-id="' + id + '"]');
        $listItem.addClass('selected');
        $listItem.get(0).scrollIntoViewIfNeeded();
    }

    // function setupFilterDescription() {
    // 	var description = $(_settings.elems.jqStoreFilter + '.selected').attr('data-description');
    // 	$(_settings.elems.jqStoreFilterDescription).html(description);
    // }

    // private injected event
    $(document).on('click', _settings.elems.jqStoreListLink, function (e) {
        e.preventDefault();
        // de-activate all the store items
        $(_settings.elems.jqStoreActiveListItem).removeClass('selected');
        $(_settings.elems.jqStoreListItemDetails).hide();
        // activate the selected one
        var storeItem = $(this).closest(_settings.elems.jqStoreListItem).addClass('selected');
        storeItem.find(_settings.elems.jqStoreListItemDetails).show();
        var id = storeItem.data('id');
        focusToMarker(id);
    });

    // $(document).on('click', _settings.elems.jqStoreFilterAll, function (e) {
    // 	//clear the rest of the checkboxes
    // 	$('#tab-1 input:checkbox:checked').not(this).prop('checked', false);
    // });

    $(document).on('click', _settings.elems.jqStoreFilter, function (e) {
        e.preventDefault();
        var filterIDs = $('#tab-1 input:checkbox:checked').map(function () {
            if (!$(this).val().endsWith('Service'))
                return $(this).val();
        }).get(); // <----array


        var filterServiceIDs = $('#tab-1 input:checkbox:checked').map(function () {
            if ($(this).val().endsWith('Service'))
                return $(this).val();
        }).get(); // <----array        

        if (filterIDs != undefined && (filterIDs.length > 0 || filterServiceIDs.length > 0 ||
            ($('.jsFilterbrands').length && $('.jsFilterbrands').val() != undefined && $('.jsFilterbrands').val() != ''))) {
            var newUrl = $(this).attr('href');
            var productsStr = getUrlVars(newUrl)['f'];
            if (productsStr != undefined && productsStr != '') {
                // clear product filters first
                newUrl = newUrl.replace(productsStr, 'products%3d' + filterIDs.join('%252c'));
                newUrl = newUrl + '%26services%3d' + filterServiceIDs.join('%252c');                
            }

            if ($('.jsFilterbrands').val() != undefined && $('.jsFilterbrands').val() != '')
            {
                newUrl = newUrl + '%26brands%3d' + $('.jsFilterbrands').val();
            }

            window.location.href = newUrl;
        }
    });


    /******************************************************************************/
    /*
	 * public functions
	 */

    // find a dealer page
    window.sf_initialize_finder = function () {
        initializeMap();
        initializeAutoComplete();
        // setupFilterDescription();
        setAutoComplete();
        findStore();
    };

    // dealer detail page
    window.sf_initialize_dealer = function () {
        initializeMap();
        initializeAutoCompleteTop();
        // setupFilterDescription();
        drawSingleMapMarker();
    };

    sf.initialize = function (settings) {
        $.extend(true, _settings, settings);
        var searchBox = $('#address2');
        if (searchBox.length > 0) {
            getApiScript(_urls.js_finder());
        } else {
            getApiScript(_urls.js_dealer());
        }
    };

}(jQuery, window.STORE_FINDER = window.STORE_FINDER || {}, window.SWITCH));



/*********************************************************************************/
/* Page Code
 */
(function ($) {

    function showLoader() {
        $('#address2').parent().find('.input-group-addon').removeClass('hide');
    }

    function hideLoader() {
        $('#address2').parent().find('.input-group-addon').addClass('hide');
    }

    // document.ready
    $(function () {
        var isElementExist = $('#map-canvas').length;
        if (isElementExist) { // for find a dealer page and dealer detail page
            var centerLat = parseFloat($('#map-canvas').data('center-lat'));
            var centerLng = parseFloat($('#map-canvas').data('center-lng'));
            var defaultZoom = parseInt($('#map-canvas').data('default-zoom'));
            var country = $('#map-canvas').data('country');
            var settings = {
                // storesFolderId: $('#storesFolderId').val(),
                center: { lat: centerLat, lng: centerLng },
                zoom: defaultZoom,
                country: country
                // elems: {
                // 	geocodeInput: 'address2'
                // }
            };
            window.STORE_FINDER.initialize(settings);
        } else {
            // initialize auto complete for "Find A Dealer" in top utility navigation
            if (document.getElementById('address1')) {
                var _autocompleteTop = new google.maps.places.Autocomplete(
                    document.getElementById('address1'), {
                        types: ['(regions)'],
                        componentRestrictions: { country: $('#address1').data('country') }
                    }
                );
                google.maps.event.addListener(_autocompleteTop, 'place_changed', function () {
                    var getPlaceVar = _autocompleteTop.getPlace();

                    localStorage.setItem('place', JSON.stringify(getPlaceVar));

                    if (!getPlaceVar.geometry || !getPlaceVar.geometry.location) {
                        // User pressed the Enter key, or the Place Details request failed.
                        window.alert("Please enter a valid suburb or postcode and select from the list");
                        return;
                    }

                    if ($('#jsfindDealerSubmit').length && getPlaceVar.address_components != null) {
                        $(".list-selection").hide();
                        $('#jsfindDealerSubmit').submit();
                    } else {

                        $(".list-selection").show();
                        return;
                    }
                });
            }
        }

        if ($("#address1").length) {
            document.getElementById("address1").addEventListener('input', function (e) {
                if (!e.value) {
                    $(".list-selection").hide();
                }
            });
        }

        if ($("#address2").length) {
            document.getElementById("address2").addEventListener('input', function (e) {
                if (!e.value) {
                    $(".select-from-list").hide();
                }
            });
        }

        //prevent find dealer form submit by pressing enter key
        if ($('#jsfindDealerSubmit').length) {
            $('#jsfindDealerSubmit').on('keyup keypress', function (e) {
                var keyCode = e.keyCode || e.which;
                if (keyCode === 13) {
                    e.preventDefault();
                    return false;
                }
            });
        }

        if ($('#jsPagefindDealerSubmit').length) {
            $('#jsPagefindDealerSubmit').on('keyup keypress', function (e) {
                var keyCode = e.keyCode || e.which;
                if (keyCode === 13) {
                    e.preventDefault();
                    return false;
                }
            });
        }
    });

}(jQuery));
